import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=67247720&lang=html"
import script from "./activities.vue?vue&type=script&lang=js"
export * from "./activities.vue?vue&type=script&lang=js"
import style0 from "./activities.vue?vue&type=style&index=0&id=67247720&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports